<template>
  <div class="right-area" :class="[{'hide-right': !state.rightPanelVisible}]">
    <component
      :goods-fields.sync="goodsFields"
      :userFontList="userFontList"
      :is="state.activeComponent.editType"
      :key="state.activeComponent.componentId"
      v-if="state.activeComponent && state.multipleComponentList.length <= 1"
      @createImg="createImg"
    />
    <tumeng-program-edit v-else/>
  </div>
</template>

<script>
import store from '../../../store/index.js'
import TumengProgramEdit from '../../tumeng-program-edit/src/index.vue'
import TumengTextEdit from '../../tumeng-text-edit/src/index.vue'
import TumengNumberEdit from '../../tumeng-number-edit/src/index.vue'
import TumengMultiImgEdit from '../../tumeng-multi-img-edit/src/index.vue'
import TumengPriceTagEdit from '../../tumeng-price-tag-edit/src/index.vue'
import TumengVideoEdit from '../../tumeng-video-edit/src/index.vue'
import TumengAdEdit from '../../tumeng-ad-edit/src/index.vue'
import TumengTimeEdit from '../../tumeng-time-edit/src/index.vue'
import TumengQRCodeEdit from '../../tumeng-qr-code-edit/src/index.vue'
import TumengBARCodeEdit from '../../tumeng-bar-code-edit/src/index.vue'
import TumengValuationEdit from '../../tumeng-valuation-edit/src/index.vue'

export default {
  name: 'RightArea',
  props: {
    goodsFields: {
      type: Array,
      default: function() {
        return []
      }
    },
    userFontList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  components: {
    TumengProgramEdit,
    TumengTextEdit,
    TumengNumberEdit,
    TumengMultiImgEdit,
    TumengPriceTagEdit,
    TumengQRCodeEdit,
    TumengBARCodeEdit,
    TumengVideoEdit,
    TumengAdEdit,
    TumengTimeEdit,
    TumengValuationEdit
  },
  data() {
    return {
      state: store.state
    }
  },
  methods: {
    createImg(goodsId, priceTagId, componentId) {
      this.$emit('createImg', goodsId, priceTagId, componentId)
    }
  }
}
</script>

<style lang="scss" scoped>
.right-area {
  position: absolute;
  right: 0;
  top: 48px;
  bottom: 0;
  width: 300px;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .12), 0 0 6px 0 rgba(0, 0, 0, .04);
  overflow: auto;
  transition: 0.3s width;

  &.hide-right {
    width: 0;
  }
}
</style>
